<script setup lang="ts">
import type { Validation } from '@vuelidate/core';
import type { OurCourierAddress } from '../../types/Address';
import { OurCourierSchema } from '../../constants/formSchemas/AddressesSchema';

const props = defineProps<{ data: OurCourierAddress, v$: Validation<object>, disabled?: boolean }>();
const emit = defineEmits<{
  (e: 'change', value: string | undefined, field: string): void
}>();
function onChange(value: string | undefined, field: string) {
  emit('change', value, field);
};

function onText(payload: Event) {
  emit('change', (payload.target as any)?.value, 'note');
}
</script>

<template>
  <div class="pd-form-cols-2">
    <FormItem
      v-for="schema in OurCourierSchema"
      :key="schema.field"
      :model-value="(props.data as any)[schema.field]"
      v-bind="schema"
      :v$="props.v$"
      :disabled="props.disabled ?? false"
      @change="onChange"
    />

    <FormItem class="md:col-span-2" field="note" :label="$t('addresses.note')">
      <Textarea
        id="note"
        :value="props.data.note"
        class="w-full"
        :rows="3"
        :cols="30"
        :disabled="props.disabled ?? false"
        @change="onText"
      />
    </FormItem>
  </div>
  <Message severity="warn">
    {{ $t('addresses.infoOurDelivery') }}
  </Message>
</template>

<style scoped></style>
